export const STOPPED_RESPONSE_DIVIDER_TEST_IDS = {
  container: 'chatbot-stopped-response-divider',
};
